<template>
  <div class="borrowings">
    <h2>
      Financial Borrowings
    </h2>
    <h3>Total financial borrowings of neighbouring councils as at 30 June 2025</h3>
    <canvas id="borrowChart"></canvas>
  </div>
</template>

<script>
    import Chart from "chart.js";
    import ChartDataLabels from 'chartjs-plugin-datalabels';
    Chart.plugins.unregister(ChartDataLabels);

    export default {
        name: "Borrowings",
        methods: {
            makeChart: async function() {
                let config = {
                    type: 'bar',
                    data: {
                        labels: [],
                        datasets: [
                            {
                                label: 'Amount borrowed',
                                data: [],
                                backgroundColor: [],
                            }
                        ]
                    },
                    plugins: [ChartDataLabels],
                    options: {
                        animation: {
                            duration: 3000
                        },
                        plugins: {
                            datalabels: {
                                anchor: 'end',
                                align: 'top',
                                fontFamily: "'Arial', sans-serif",
                                formatter: (v) => {
                                    return '$' + v + 'm';
                                }
                            }
                        },
                        title: {
                            display: false,
                            fontFamily: "'Arial', sans-serif",
                            text: "Total financial borrowings of neighbouring councils as at 30 June 2024"
                        },
                        tooltips: {
                            callbacks: {
                                label: (item, data) => {
                                    let label = data.datasets[item.datasetIndex].label || '';
                                    if (label) {
                                        label += ': ';
                                    }
                                    label += `$${item.yLabel.toLocaleString()}m`;
                                    return label;
                                }
                            },
                            mode: 'index',
                            intersect: false
                        },
                        legend: {
                            display: false
                        },
                        scales: {
                            yAxes: [{
                                ticks: {
                                    min: 0,     // KI 6Jun2024. Added below THREE LINES. Due to..
                                    max: 240,   // Liverpool run off graph can't see. CAN CHANGE!!!
                                    stepSize: 20,  // KI. ENDED.
                                    beginAtZero: true,
                                    fontFamily: "'Arial', sans-serif",
                                    callback: function(value) {
                                        return '$' + value + 'm';
                                    }
                                },
                            }],
                            xAxes: [{
                                ticks: {
                                    fontFamily: "'Arial', sans-serif",
                                    fontStyle: "bold"
                                },
                            }]
                        }
                    }
                };
                let councilData = await (await fetch('data/borrowing.json')).json();
                councilData.forEach((council) => {
                    config.data.labels.push(council['name']);
                    let colour = 'rgba(0, 80, 158, 1)';
                    if (council['name'] === 'Fairfield') {
                        colour = 'rgba(166, 206, 57, 1)';
                    }
                    config.data.datasets[0].backgroundColor.push(colour);
                    config.data.datasets[0].data.push(parseFloat((council['borrowedMillions']).toFixed(3)));
                });
                // eslint-disable-next-line no-unused-vars
                let chart = new Chart('borrowChart', config);
            }
        },
        mounted() {
            this.makeChart();
        }
    }
</script>

<style scoped>
  div.borrowings {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  canvas#borrowChart {
    max-width: 700px;
    max-height: 500px;
    margin-bottom: 1rem;
  }

  p, ul, h3 {
    max-width: 100%;
  }
</style>